// Get Performance Creators
export const GET_PERFORMANCE_CREATORS_REQUEST = 'GET_PERFORMANCE_CREATORS_REQUEST';
export const GET_PERFORMANCE_CREATORS_DONE = 'GET_PERFORMANCE_CREATORS_DONE';
export const GET_PERFORMANCE_CREATORS_FAILED = 'GET_PERFORMANCE_CREATORS_FAILED';

// Operations
export const UPDATE_USER_PERFORMANCE_CREATORS = 'UPDATE_USER_PERFORMANCE_CREATORS';
export const TOGGLE_PERFORMANCE_CREATORS = 'TOGGLE_PERFORMANCE_CREATORS';
export const TOGGLE_ALL_PERFORMANCE_CREATORS = 'TOGGLE_ALL_PERFORMANCE_CREATORS';
export const SET_PERFORMANCE_CREATORS_FILTER = 'SET_PERFORMANCE_CREATORS_FILTER';
export const SET_PERFORMANCE_CREATORS_ALL_FILTERS = 'SET_PERFORMANCE_CREATORS_ALL_FILTERS';
export const CLEAR_PERFORMANCE_CREATORS_FILTERS = 'CLEAR_PERFORMANCE_CREATORS_FILTERS';
export const PERFORMANCE_CREATORS_SET_PAGE = 'PERFORMANCE_CREATORS_SET_PAGE';
export const PERFORMANCE_CREATORS_ERRORS_RESET = 'PERFORMANCE_CREATORS_ERRORS_RESET';
export const PERFORMANCE_CREATORS_RESET = 'PERFORMANCE_CREATORS_RESET';